module.exports = __webpack_public_path__ + "img/undraw_Terms_re_6ak4.861f27a1.svg";